// wc-reveal-format.js — pure, DOM-free decision for the reveal modal's
// pre-selected format. Shared by the result renderer and the A/B renderers so
// BOTH arms (original + version B) behave identically.
//
// WHY: the product page advertises Canvas Print at $44.97. To meet that price
// expectation, a NEW generation's reveal opens on plain Canvas (not the pricier
// Framed). On a reopen / re-render of the SAME generation we keep whatever the
// customer last chose ("remember their last choice" — operator decision
// 2026-05-25).

/**
 * @param {boolean} isCanvasParent  entry product is a canvas product
 * @param {boolean} wasSameGen      true when re-rendering the same generation
 * @param {string=} currentFormat   the format currently selected, if any
 * @returns {'canvas'|'canvas_framed'|'paint_kit'}
 */
export function pickRevealFormat(isCanvasParent, wasSameGen, currentFormat) {
  if (wasSameGen && currentFormat) return currentFormat; // remember last choice
  return isCanvasParent ? 'canvas' : 'paint_kit';        // new-reveal default
}
